// 3rd Party imports
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";

// Local imports
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import "./LatestBrandCollection.css";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const LatestBrandCollection = ({ data }) => {
  const is1440Screen = useMediaQuery("(max-width:1440px)");
  const is1024Screen = useMediaQuery("(max-width:1024px)");
  const is768Screen = useMediaQuery("(max-width:768px)");
  const is480Screen = useMediaQuery("(max-width:480px)");
  const imageWidth = is480Screen
    ? "180px"
    : is768Screen
    ? "220px"
    : is1024Screen
    ? "280px"
    : is1440Screen
    ? "350px"
    : "450px";

  const imageHeight = is480Screen
    ? "160px"
    : is768Screen
    ? "210px"
    : is1024Screen
    ? "250px"
    : is1440Screen
    ? "295px"
    : "340px";
  const navigate = useNavigate();
  const [carouselImages, setCarouselImages] = useState([]);
  const [cardItems, setCardItems] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0); // State to track the current slide index
  const [brandData, setBrandData] = useState([]);

  useEffect(() => {
    if (data) {
      const images = data.map((item) => item.brand_image_url);
      setCarouselImages(images);
      const filterOutProductImages = data?.map(
        (item) => item?.brand_product || []
      );
      setCardItems(filterOutProductImages);
      setBrandData(data);
    }
  }, [data]);

  const handleSlideChange = (index) => {
    setCurrentSlide(index); // Update the current slide index when carousel changes
  };

  const handleImageClick = (item) => {
    navigate(`/productDetail/${item?.product_id}`, {
      state: { productId: item?.product_id },
    });
  };
  const handleBrandClick = (brand) => {
    navigate("/categories-by-brand", { state: { fromBrands: true, brand } });
  };

  return (
    <>
      <div className="latestBrandCollection">
        <div className="heading">
          <h1>Latest Brand Collection</h1>
        </div>
        {brandData ? (
          <div className="containt-latest-brand-collection">
            <div className="left-side">
              {carouselImages.length > 0 && (
                <Carousel
                  infiniteLoop
                  showThumbs={false}
                  showStatus={false}
                  interval={4000}
                  emulateTouch
                  dynamicHeight={false}
                  showArrows={true}
                  onChange={handleSlideChange} // Capture slide change
                  renderArrowPrev={(onClickHandler, hasPrev, label) =>
                    hasPrev && (
                      <button
                        type="button"
                        onClick={onClickHandler}
                        title={label}
                        className="carousel-arrow prev"
                        // style={{backgroundColor:"green"}}
                      >
                        <ChevronLeftIcon
                          className="carousel-icon"
                          style={{ fontSize: "60px" }}
                        />
                      </button>
                    )
                  }
                  renderArrowNext={(onClickHandler, hasNext, label) =>
                    hasNext && (
                      <button
                        type="button"
                        onClick={onClickHandler}
                        title={label}
                        className="carousel-arrow next"
                      >
                        <ChevronRightIcon
                          className="carousel-icon"
                          style={{ fontSize: "60px" }}
                        />
                      </button>
                    )
                  }
                >
                  {carouselImages?.map((image, index) => (
                    <div
                      key={index}
                      onClick={() => handleBrandClick(data[index])}
                      style={{ backgroundColor: "", width: "100%" }}
                    >
                      <div className="img">
                        <CustomImageComponent
                          width={"100%"}
                          height={"100%"}
                          src={`${image}`}
                        />
                      </div>
                    </div>
                  ))}
                </Carousel>
              )}
            </div>
            <div className="right-side">
              {cardItems[currentSlide]?.map((item, index) => (
                <div
                  className="card-imgs"
                  onClick={() => handleImageClick(item)}
                  key={index}
                  style={{ cursor: "pointer" }}
                >
                  <div className="img" style={{ border: "0px solid red" }}>
                    <CustomImageComponent
                      height={imageHeight}
                      width={imageWidth}
                      src={`${item?.product_image?.product_image_url}`}
                      style={{ borderRadius: "10px" }}
                    />
                  </div>
                  <div className="p">
                    {/* <p className="p1">{item.product_name}</p> */}
                    {/* <p className="p1">"nameee"</p> */}
                    {/* <p className="p2">{item.price}</p> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p style={{ backgroundColor: "pink" }}>
            No Latest brand collections available
          </p>
        )}
      </div>
    </>
  );
};

export default LatestBrandCollection;
